import { ReactNode } from "react";

import PullToRefresh from "components/PullToRefresh";
import Suspense from "components/shared/Suspense";
import LoadingBook from "hardcover-ui/components/LoadingBook";
import classNames from "lib/classNames";

export default function PageWrapper({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <Suspense fallback={<LoadingBook />}>
      <div className={classNames("min-h-screenHeightWithoutHeader", className)}>
        <PullToRefresh>{children}</PullToRefresh>
      </div>
    </Suspense>
  );
}
